import { useState, useContext } from "react";
import { UserStar } from "lucide-react";
import { MasajidContext } from "../contexts/MasajidContext";

function MyMasjidButton({ username }) {
  const { setMyMasjidUsername, unsetMyMasjid, isMyMasjid, language } =
    useContext(MasajidContext);
  const [isAnimating, setIsAnimating] = useState(false);
  const isMyMasjidSet = isMyMasjid(username);

  const handleToggle = () => {
    if (isMyMasjidSet) {
      unsetMyMasjid();
    } else {
      setMyMasjidUsername(username);
    }
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 300);
  };

  const buttonText = {
    remove: language === "urdu" ? "میری مسجد ہٹائیں" : "Remove as My Masjid",
    set: language === "urdu" ? "میری مسجد مقرر کریں" : "Set as My Masjid",
  };

  return (
    <button
      onClick={handleToggle}
      style={{
        background: isMyMasjidSet
          ? "rgba(34, 197, 94, 0.3)"
          : "rgba(34, 197, 94, 0.1)",
        border: "3px solid #22c55e",
        borderRadius: "24px",
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        fontSize: "16px",
        fontWeight: "600",
        color: "rgb(255, 255, 255, 0.9)",
        width: "100%",
        boxSizing: "border-box",
        transform: isAnimating ? "scale(1.05)" : "scale(1)",
      }}
      aria-label={isMyMasjidSet ? buttonText.remove : buttonText.set}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          minWidth: "100px",
        }}
      >
        <UserStar
          size={20}
          color="#22c55e"
          fill={isMyMasjidSet ? "#22c55e" : "none"}
          strokeWidth={2}
          style={{ flexShrink: 0 }}
        />
        <span
          style={{ whiteSpace: "nowrap" }}
          lang={language === "urdu" && "ur"}
        >
          {isMyMasjidSet ? buttonText.remove : buttonText.set}
        </span>
      </div>
    </button>
  );
}

export default MyMasjidButton;
